import { render } from "./OrderDetailsView.vue?vue&type=template&id=20ccf6f0&ts=true"
import script from "./OrderDetailsView.vue?vue&type=script&lang=ts"
export * from "./OrderDetailsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__